import * as React from 'react'

import { TimeOffRoutesDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const EditLeavePage = React.lazy(() => import('modules/timeoff/pages/EditLeavePage'))
const EditMedicalLeavePage = React.lazy(() => import('modules/timeoff/pages/EditMedicalLeavePage'))
const EditMedicalLeaveUpdatePage = React.lazy(
  () => import('modules/timeoff/pages/EditMedicalLeaveUpdatePage')
)
const NewLeavePage = React.lazy(() => import('modules/timeoff/pages/NewLeavePage'))
const NewMedicalLeaveUpdatePage = React.lazy(
  () => import('modules/timeoff/pages/NewMedicalLeaveUpdatePage')
)
const RejectLeavePage = React.lazy(() => import('modules/timeoff/pages/RejectLeavePage'))
const RootPage = React.lazy(() => import('modules/timeoff/pages/RootPage'))

export const timeOffRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.timeOff.path,
    element: <RootPage />,
    handle: {
      module: 'timeoff',
      meta({ watchQuery }) {
        return watchQuery({
          query: TimeOffRoutesDocument,
        }).map(({ data }) => {
          const canManageTimeoff = data?.timeoff?._policies.companyManageTimeoff.can

          const settings = canManageTimeoff
            ? navigation.settings.timeoffPolicies.fullPath()
            : undefined

          return {
            title: i18n.t('sidebar.time_off'),
            settings: settings,
          }
        })
      },
    },
    children: [
      {
        path: navigation.timeOff.leavesNew.path,
        element: <NewLeavePage />,
      },
      {
        path: navigation.timeOff.leavesEditLeaveId.path,
        element: <EditLeavePage />,
      },
      {
        path: navigation.timeOff.leavesRejectLeaveId.path,
        element: <RejectLeavePage />,
      },
      {
        path: navigation.timeOff.leaveUpdatesLeaveIdEditMedicalLeave.path,
        element: <EditMedicalLeavePage />,
      },
      {
        path: navigation.timeOff.leaveUpdatesLeaveIdNew.path,
        element: <NewMedicalLeaveUpdatePage />,
      },
      {
        path: navigation.timeOff.leaveUpdatesLeaveIdEditLeaveUpdateId.path,
        element: <EditMedicalLeaveUpdatePage />,
      },
    ],
  },
]
